/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2023-05-15 09:19:05
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-07-04 20:25:19
 */
/**
 * 自定义指令添加
 */
import type { App } from 'vue'
import { useAuthStore } from '@/store'

export default {
  install(app: App) {

    app.directive('hasPermissions', {
      updated(el, binding: { value: string }) {
        const authStore = useAuthStore()
        const buttonList: any = authStore.buttonList
        if (!buttonList.includes(binding.value)) {
          el.remove()
        }
      },
      mounted(el, binding: { value: string }) {
        const authStore = useAuthStore()
        const buttonList: any = authStore.buttonList
        if (!buttonList.includes(binding.value)) {
          el.remove()
        }
      }
    })
  }
}
